import { Injectable } from '@angular/core';
import { DemandDetails, DemandList, DwoDiagnoseCauseReasonTemplate, DwoDiagnoseCauseReasonTemplateList } from '../business-entities/dwo-diagnose-model';
import { DwoAppointemntSubCheckListViewModel } from '../business-entities/dwo-sub-check-list-detail-view-model';
import { DWOCheckListRequestModel } from '../business-entities/dwo-sub-check-list-view-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DwoDiagnoseDataService } from '../data-services/dwo-diagnose-data.service';
@Injectable({
  providedIn: 'root'
})
export class DwoDiagnoseBusinessService {
  demandId:number
  DiagnoseList: DwoDiagnoseCauseReasonTemplate[];
  CauseList: DwoDiagnoseCauseReasonTemplate[];
  ReasonList: DwoDiagnoseCauseReasonTemplate[];
  CauseCodeList: DwoDiagnoseCauseReasonTemplate[];
  checkList: DwoAppointemntSubCheckListViewModel[];
  isSSM:boolean;
  isEditDwoDiagnose:boolean=false;
  DiagnoseFormName:string;
  formName:string;
  editFormName:string;

  constructor(private checkListDataService: DwoDiagnoseDataService) { }

  getCheckList(param: DWOCheckListRequestModel): Promise<GenericResponse<Array<DwoAppointemntSubCheckListViewModel>>> {
    return this.checkListDataService.getCheckList(param);
  }

  getDemandList(appointmentId: number): Promise<GenericResponse<Array<DemandList>>>{
      return this.checkListDataService.getDemandList(appointmentId)
  }

  getDemandDetails(appointmentGUID:string, appointmentDemandNo:number):Promise<GenericResponse<Array<DemandDetails>>>{
    return this.checkListDataService.getDemandDetails(appointmentGUID,appointmentDemandNo)
  }

  getDiagnoseCauseResonList(language:string,brand:string):Promise<GenericResponse<DwoDiagnoseCauseReasonTemplateList>>{
    return this.checkListDataService.getDiagnoseCauseResonList(language,brand)
  }
  
  // getJobDiagnoseCauseList(appointmentGuid:string,appointmentDemandNo:any):Promise<GenericResponse<any>>{
  //   return this.checkListDataService.getJobDiagnoseCauseList(appointmentGuid,appointmentDemandNo)
  // }

  // getDiagnoseCauseList(languageCode:any):Promise<GenericResponse<any>>{
  //   return this.checkListDataService.getDiagnoseCauseList(languageCode)
  // }
  SaveJobDiagnoseCauseReason(model:any):Promise<GenericResponse<any>>{
    return this.checkListDataService.SaveJobDiagnoseCauseReason(model)
  }
  SaveCheckList(model:any):Promise<GenericResponse<any>>{
    return this.checkListDataService.SaveCheckList(model)
  }

  getSstCheckList(appointmentId: any)
  {
    return this.checkListDataService.getSstCheckList(appointmentId);
  }
}
